
































import { Component, Vue } from 'vue-property-decorator';
import { hideOverlay } from '@/util/common/overlay';
@Component({
  name: 'NoAccess'
})
export default class NoAccess extends Vue {
  private messagesStr1: string = '';
  private messagesStr2: string = '';
  private async mounted() {
    hideOverlay();
    this.messagesStr1 = this.$route.params.message1 as string;
    this.messagesStr2 = this.$route.params.message2 as string;
  }
}
